import { ALIAS_EVENTS, ALIAS } from '../../enum/constants';

export enum TYPE {
  DEAL = 'DEAL',
  LEAD = 'LEAD',
}

export enum EVENT {
  ADDED = 'ADDED',
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  REMOVED = 'REMOVED',
}

export const alias: Record<string, string> = {
  'column': ALIAS.COLUMN,
  'column_id': ALIAS.COLUMN_ID,
  'contact': ALIAS.CONTACT,
  'contact_id': ALIAS.CONTACT_ID,
  'funnel': ALIAS.FUNNEL,
  'funnel_id':ALIAS.FUNNEL_ID,
  'lead': ALIAS.LEAD,
  'deal':ALIAS.DEAL,
  'price':ALIAS.PRICE,
  'currency': ALIAS.CURRENCY,
  'title': ALIAS.TITLE,
  'name': ALIAS.NAME,
  'bg_color': ALIAS.BG_COLOR,
  'text_color': ALIAS.TEXT_COLOR,
  'comment': ALIAS.COMMENT
};

export const alias_ = {
};

export const alias_events: any = {
  [EVENT.CREATE]: ALIAS_EVENTS.CREATED,
  [EVENT.UPDATE]: ALIAS_EVENTS.UPDATED,
  [EVENT.ADDED]: ALIAS_EVENTS.ADDED,
  [EVENT.REMOVED]: ALIAS_EVENTS.REMOVED,
};

export interface IActivity {
  entity_uuid: string;
  external_type: TYPE;
  event_type: EVENT;
  old_data: any;
  new_data: any;
}
